import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import {isOLG} from '../../actions/root_url'

const MixProductTypeRadios = React.createClass({
  render() {
    return (
      <Row>
        <Col xs={4}>
          <label style={{ paddingLeft: '0px' }} className="col-xs-4 search-by-max-width">
            <Translate value="search_type" />
          </label>
        </Col>
        <div className="form-group" id="search-product-by">
          <label className="col-xs-3 pl">
            <input
              type="radio"
              value="RefNum"
              onChange={this.props.handleOptionChange}
              checked={this.props.value === 'RefNum'}
            />
            <Translate value={isOLG ? "item_no" : "ref_num"} />
          </label>
          <label className="col-xs-3" >
            <input
              type="radio"
              value="Name"
              onChange={this.props.handleOptionChange}
              checked={this.props.value === 'Name'}
            />
            <Translate value="name" />
          </label>
        </div>
      </Row>
    );
  },
});

export default MixProductTypeRadios;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/MixProductTypeRadios.jsx